/*
 * Labelled form field. Bordered input row with optional icon and
 * trailing slot. Error or help text below. Extra props go to the
 * input.
 */
import React, { forwardRef } from 'react'
import Icon from './Icon'

const labelStyle = {
    display: 'block',
    font: 'var(--gp-caption)',
    color: 'var(--gp-ink-mute)',
    marginBottom: 6,
}

const fieldRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '11px 14px',
    background: 'var(--gp-card)',
    border: '1px solid var(--gp-hairline)',
    borderRadius: 'var(--gp-r-md)',
}

const inputStyle = {
    flex: 1,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    font: '400 14px/1 var(--gp-font)',
    color: 'var(--gp-ink)',
    width: '100%',
}

const errorTextStyle = {
    font: 'var(--gp-caption)',
    color: 'var(--gp-danger)',
    marginTop: 6,
}

const helpTextStyle = {
    font: 'var(--gp-caption)',
    color: 'var(--gp-ink-mute)',
    marginTop: 6,
}

const renderIcon = (icon) => {
    if (!icon) return null
    if (typeof icon === 'string') {
        return (
            <Icon
                name={icon}
                size={22}
                stroke={1.75}
                style={{ color: 'var(--gp-ink-mute)' }}
            />
        )
    }
    return icon
}

const GpFormField = forwardRef(function GpFormField(
    {
        label,
        icon,
        error,
        helpText,
        trailing,
        disabled = false,
        rowStyle,
        inputStyle: inputStyleOverride,
        ...inputProps
    },
    ref
) {
    return (
        <div>
            {label && <label style={labelStyle}>{label}</label>}
            <div
                style={{
                    ...fieldRow,
                    opacity: disabled ? 0.6 : 1,
                    ...rowStyle,
                }}
            >
                {renderIcon(icon)}
                <input
                    ref={ref}
                    disabled={disabled}
                    style={{ ...inputStyle, ...inputStyleOverride }}
                    {...inputProps}
                />
                {trailing}
            </div>
            {error ? (
                <div style={errorTextStyle}>{error}</div>
            ) : helpText ? (
                <div style={helpTextStyle}>{helpText}</div>
            ) : null}
        </div>
    )
})

export default GpFormField
